angular.module('FlexyBeautyApp.services').
    factory('Monitoring_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/monitoring/' , {} ,
            {
                logHealth:   { method: 'POST', url: baseUrl + 'rest/monitoring/logHealth'},
            }
        );
    }]);
angular.module('FlexyBeautyApp.services').
    factory('MonitoringSrv',["Monitoring_Resource",
        function (Monitoring_Resource) {
            let monitoringSrv = {
                alreadySent: false
            };

            monitoringSrv.logHealth = function (applicationName, healthValue, loadingTimes) {
                if(!monitoringSrv.alreadySent) {
                    monitoringSrv.alreadySent = true;
                    let monitoringResource = new Monitoring_Resource();
                    monitoringResource.applicationName = applicationName;
                    monitoringResource.health = healthValue;
                    monitoringResource.loadingTimes = loadingTimes;
                    return monitoringResource.$logHealth({}).then(
                        function () {
                            console.log("MonitoringSrv.save - success");
                        },
                        function () {   //failure
                            monitoringSrv.alreadySent = false;
                            console.log("MonitoringSrv.save - failure");
                        }
                    );
                }

                return Promise.resolve();
            };

            return monitoringSrv;
        }]);
angular.module('FlexyBeautyApp.services')
    .factory('MonitoringHealthState', [function (gettextCatalog) {
        return {
            OK : "OK",
            KO : "KO"
        };
    }]);
angular.module('FlexyBeautyApp.services')
    .factory('MonitoringApplication', [function (gettextCatalog) {
        return {
            PROBACKOFFICE : "PROBACKOFFICE",
            WEBSITE : "WEBSITE"
        };
    }]);


// WEBPACK FOOTER //
// ./js/services/models/Monitoring.js